import { getStaticImageUrl } from '@utils/createImageUrl';

const AdviceProcess = ({ isMobile }: { isMobile?: boolean }) => {
  return (
    <div className="for-lawyer__advice-content">
      <div className="for-lawyer-advice-step-image">
        {isMobile ? (
          <>
            <img
              className="for-lawyer-advice-step-img for-lawyer-advice-step-2-img"
              src={getStaticImageUrl({ fileName: 'preview/client-call.png' })}
            />
            <img
              className="for-lawyer-advice-step-img for-lawyer-advice-step-3-img"
              src={getStaticImageUrl({ fileName: 'preview/advice-list.png' })}
            />
          </>
        ) : (
          <>
            <img
              className="for-lawyer-advice-step-img for-lawyer-advice-step-2-img"
              src={getStaticImageUrl({ fileName: 'preview/client-call-desktop.png' })}
            />
            <img
              className="for-lawyer-advice-step-img for-lawyer-advice-step-3-img"
              src={getStaticImageUrl({ fileName: 'preview/advice-list.png' })}
            />
          </>
        )}
      </div>
      <div className="for-lawyer-advice-step-desc-container">
        <div className="for-lawyer-advice-step-desc for-lawyer-advice-step-1">
          상담 전, 의뢰인이 남긴 상담 내용을 확인한다.
          <br />
          개요를 간단히 파악한 후 메모를 남겨뒀다.
        </div>
        <div className="for-lawyer-advice-step-desc for-lawyer-advice-step-2">
          예약된 시간에 맞춰 의뢰인에게 직접 전화를 걸었다.
          <br />
          사전에 준비한 내용을 토대로 법률 상담을 진행했다.
        </div>
        <div className="for-lawyer-advice-step-desc for-lawyer-advice-step-3">
          상담 종료 후 결과지를 작성한다.
          <br />
          승소 가능성이 매우 높은 사건이라는 의견을 남겼다.
        </div>
      </div>
      <div className="for-lawyer__slide-circle-container">
        <div className="for-lawyer__slide-circle white active" />
        <div className="for-lawyer__slide-circle white" />
        <div className="for-lawyer__slide-circle white" />
      </div>
    </div>
  );
};

export default AdviceProcess;
